module.exports = {"env":"production","appUrl":"https://app.hemonaplo.hu","apiUrl":"https://api.hemonaplo.hu","functionsUrl":"https://sls.hemonaplo.hu"}